import React from 'react';
import {
    BasicInput,
    OemCheckbox,
    PriceInput,
    QuantityInput,
    CurrencyField,
    widthFormatter,
    DependentDropdown,
    DeleteRowButton,
    HeaderFormatter
} from '../Formatters';
import styles from './TableConfig.module.css';

export const PARTS_MARKUP_COLS = [
    {
        text: '',
        dataField: '',
        isDummyColumn: true,
        style: {
            ...widthFormatter('deleteCol'),
            padding: 0
        },
        align: 'center',
        footerClasses: [styles.footer, styles.noborder, styles.trashIcon],
        formatter: (col, row, rowI) => (
            <DeleteRowButton
                rowId={row.id}
                rowIndex={rowI}
                tableType='partsMarkup'
            />
        )
    },
    {
        dataField: 'qty',
        text: 'Qty',
        style: widthFormatter('qtyCol'),
        formatter: (col, row, rowI) => (
            <div className={styles.makeQuantityInputCenter}>
                <QuantityInput
                    cell={col}
                    row={row}
                    rowIndex={rowI}
                    fieldName={'qty'}
                    tableType='partsMarkup'
                />
            </div>
        )
    },
    {
        dataField: 'oem',
        text: 'In OEM Warranty',
        style: widthFormatter('oemCol'),
        formatter: (col, row, rowI) => (
            <OemCheckbox
                row={row}
                rowIndex={rowI}
                fieldName={'oem'}
                tableType='partsMarkup'
            />
        ),
        headerFormatter: (col) => (
            <HeaderFormatter
                col={col}
                centered={true}
                toolTipRequired={true}
                fieldName={'oem'}
            />
        )
    },
    {
        dataField: 'asset',
        text: 'Asset',
        style: widthFormatter('assetPartsMarkupCol'),
        classes: styles.partsAssetWidth,
        formatter: (col, row, rowI) => (
            <DependentDropdown
                cell={col}
                row={row}
                rowIndex={rowI}
                tableType='partsMarkup'
                fieldName={'asset'}
            />
        )
    },
    {
        dataField: 'partNumber',
        text: 'Part Number',
        style: widthFormatter('assetPartsCol'),
        formatter: (col, row, rowI) => (
            <BasicInput
                cell={col}
                row={row}
                tableType='partsMarkup'
                rowIndex={rowI}
                fieldName={'partNumber'}
            />
        )
    },
    {
        dataField: 'description',
        text: 'Description',
        style: widthFormatter('assetPartsDescCol'),
        formatter: (col, row, rowI) => (
            <DependentDropdown
                cell={col}
                row={row}
                rowIndex={rowI}
                tableType='partsMarkup'
                fieldName={'description'}
            />
        )
    },
    {
        dataField: 'price',
        text: 'Price',
        headerAlign: 'left',
        align: 'right',
        style: widthFormatter('totalCol'),
        formatter: (c, r, rI) => (
            <PriceInput
                cell={c}
                row={r}
                rowIndex={rI}
                fieldName={'price'}
                tableType='partsMarkup'
            />
        )
    },
    {
        dataField: 'markup',
        text: 'Markup',
        headerAlign: 'left',
        align: 'right',
        style: widthFormatter('invoiceTotalCol'),
        formatter: (c, r, rI) => (
            <PriceInput
                cell={c}
                row={r}
                rowIndex={rI}
                fieldName={'markup'}
                tableType='partsMarkup'
            />
        )
    },
    {
        dataField: 'total',
        text: 'Total',
        headerAlign: 'left',
        align: 'right',
        classes: styles.partsWidth,
        formatter: (col, row, i) => {
            return (
                <CurrencyField
                    col={col}
                    row={row}
                    rowIndex={i}
                    fieldName='total'
                    tableType='partsMarkup'
                />
            );
        }
    }
];
